<template>
    <th scope="col" :class="cls" :style="{fontSize: fontSize, color: color, textAlign: textAlign, fontWeight: fontWeight }">
        {{ text }}<span v-if="subText" :style="{ fontSize: subFontSize, fontWeight: 450 }">{{ subText }}</span><slot name="sub-item"></slot>
    </th>
</template>

<script>

export default {
    name: 'SummaryPanelHeaderItem',
    props: {
        type: String,
        text: String,
        fontSize: {
            type: String,
            default: '0.89rem'
        },
        subFontSize: {
            type: String,
            default: '0.73rem'
        },
        fontWeight: {
            type: String,
            default: '600'
        },
        color: {
            type: String,
            default: ''
        },
        subText: {
            type: String,
            default: ''
        },
        textAlign: {
            type: String,
            default: 'center'
        }
    },
    computed: {
        cls () {
            return this.type == 'title' ? 'title' : 'title margin-right'
        }
    }
}
</script>